<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <div>
        <div class="search-wrap">
          <el-button size="mini" @click="saveListForm">保存</el-button>
          <el-button size="mini" @click="search">查询</el-button>
          <el-button size="mini" @click="printList()" style="margin-right: 5px;">打印</el-button>
          <el-button size="mini" @click="navBack()">返回</el-button>
        </div>

        <div style="margin-bottom: 10px;">
          <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
            <el-descriptions-item label="仪表编号">
              <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="当前房产">
              <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="抄表日期">
              <div v-if="where.read_type===2">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      style="width: 100%"
                      size="mini"
                      v-model="where.start_time"
                      :clearable="false"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="2">
                    至
                  </el-col>
                  <el-col :span="11">
                    <el-date-picker
                      style="width: 100%"
                      size="mini"
                      v-model="where.end_time"
                      :clearable="false"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-col>
                </el-row>
              </div>
              <div v-if="where.read_type===1">
                <el-date-picker
                  style="width: 100%"
                  size="mini"
                  v-model="where.read_month"
                  :clearable="false"
                  type="month"
                  format="yyyy-MM"
                  value-format="yyyy-MM">
                </el-date-picker>
              </div>
              <div style="margin-top: 10px;">
                <el-radio v-model="where.read_type" :label="1">按月</el-radio>
                <el-radio v-model="where.read_type" :label="2">自定义</el-radio>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="线路">
              <el-input size="mini" placeholder="请输入收费对象" v-model="where.line" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="仪表状态">
              <el-checkbox-group v-model="where.status_ids">
                <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="抄表状态">
              <el-checkbox-group v-model="where.note_status_ids">
                <el-checkbox v-for="item in [{name:'已抄表',val:1},{name:'未抄表',val:0}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="仪表类型">
              <el-select size="mini" style="width: 100%" v-model="where.meter_type" filterable placeholder="类型" class="kuan">
                <el-option
                  v-for="item in meter_type_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="仪表性质">
              <el-checkbox-group v-model="where.meter_nature_ids">
                <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div>
          <el-table size="mini" height="47vh" width="99%" border v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55" fixed>
            </el-table-column>
            <el-table-column prop="meter_type_name" label="仪表类型" align="center" width="80" fixed></el-table-column>
            <el-table-column prop="number" label="仪表编号 " align="center" width="140" fixed>
              <template slot-scope="scope">
                <el-link type="primary" @click="edit(scope.row)">{{scope.row.number}}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="仪表名称 " align="center" width="100"></el-table-column>
            <el-table-column prop="old_dosage_number" label="去年同期用量" align="center" width="100"></el-table-column>
            <el-table-column prop="last_read_time" label="上期抄表日期" align="center" width="100"></el-table-column>
            <el-table-column prop="last_read_number" label="上期读数" align="center" width="100"></el-table-column>
            <el-table-column prop="read_number" label="本期读数" align="center" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.is_examine">{{scope.row.read_number}}</span>
                <el-input v-if="!scope.row.is_examine" :ref="'input_'+scope.$index" :data-index="'input_'+scope.$index" size="mini" placeholder="请输入本期读数" @keydown.native="nextLine(scope.row,scope.$index,$event)" @input="onDosageNumber(scope.row)" @change="isDosageNumber(scope.row,'input_'+scope.$index)" v-model="scope.row.read_number" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="read_time" label="抄表日期" align="center" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.is_examine">{{scope.row.read_time}}</span>
                <el-date-picker
                  v-if="!scope.row.is_examine"
                  style="width: 100%"
                  size="mini"
                  v-model="scope.row.read_time"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="updateTime"
                  placeholder="选择日期">
                </el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="admin_name" label="抄表人" align="center" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.is_examine">{{scope.row.admin_name}}</span>
                <el-input v-if="!scope.row.is_examine" size="mini" placeholder="请输入抄表人" v-model="scope.row.admin_name" @focus="selectUser(scope.row)" clearable></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="dosage_number" label="本期用量" align="center" width="100">
              <template slot-scope="scope">
                <span :style="{color:(scope.row.dosage_number<0?'#ff0000':'#000000')}">{{scope.row.dosage_number}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="house_name" label="所在房产" align="center" width="200"></el-table-column>
            <el-table-column prop="charging_standard_name" label="收费标准 " align="center" width="250"></el-table-column>
            <el-table-column prop="charging_standard_money" label="费用单价 " align="center" width="100"></el-table-column>
          </el-table>
        </div>

        <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
          <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
        </div>
      </div>
    </div>


    <!-- 修改窗口 -->
    <el-dialog title="编辑" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">

      <div style="max-height: 700px;overflow-y: auto;">
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <el-descriptions-item label="仪表编号">
            <el-input size="mini" class="form-input" readonly v-model="form.number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="所在房产">
            <el-input size="mini" class="form-input" readonly v-model="form.house_name" clearable
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表名称">
            <el-input size="mini" class="form-input" readonly v-model="form.name" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="倍率">
            <el-input size="mini" class="form-input" readonly v-model="form.magnification" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表户号">
            <el-input size="mini" class="form-input" readonly v-model="form.house_number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="初始读数">
            <el-input size="mini" class="form-input" readonly v-model="form.start_number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表表号">
            <el-input size="mini" class="form-input" readonly v-model="form.meter_number" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="回程">
            <el-input size="mini" class="form-input" readonly v-model="form.return_trip" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表类型">
            <!--                        <el-input size="mini" class="form-input" v-model="form.meter_type" autocomplete="off"></el-input>-->
            <el-select size="mini" style="width: 100%" readonly v-model="form.meter_type" filterable placeholder="仪表类型" class="kuan">
              <el-option
                v-for="item in meter_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="安装日期">
            <!--            <el-input size="mini" class="form-input" v-model="form.install_time" autocomplete="off"></el-input>-->
            <el-date-picker
              readonly
              v-model="form.install_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="收费标准">
            <!--            <el-input size="mini" class="form-input" v-model="form.charging_standard" autocomplete="off"></el-input>-->
            <el-select size="mini" readonly style="width: 100%" v-model="form.charging_standard" filterable placeholder="收费标准" class="kuan">
              <el-option
                v-for="item in house_charge_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="上次抄表时间">
            <!--            <el-input size="mini" class="form-input" v-model="form.reading_time" placeholder="仪表初始化时上次抄表时间" autocomplete="off"></el-input>-->
            <el-date-picker
              readonly
              v-model="form.reading_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="仪表排序">
            <el-input size="mini" class="form-input" readonly v-model="form.sort" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="位置">
            <el-input size="mini" class="form-input" readonly v-model="form.position" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表状态">
            <el-radio readonly v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]"
                      :key="item.val" v-model="form.status" :label="item.val">{{ item.name }}</el-radio>
          </el-descriptions-item>
          <el-descriptions-item label="规格">
            <el-input size="mini" readonly class="form-input" v-model="form.specifications" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="仪表性质">
            <el-radio readonly v-for="item in meter_nature_list"
                      :key="item.val" v-model="form.meter_nature" :label="item.val">{{ item.name }}</el-radio>
          </el-descriptions-item>
          <el-descriptions-item label="线路">
            <el-input size="mini" readonly class="form-input" v-model="form.line" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input readonly
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-descriptions-item>
          <el-descriptions-item label="附件">
            <UploadFilesSysc :readonly="false" :host-url="host_url" :upload-url="host_url+'/admin/MeterNote/uploadFile'" :limit="20"
                             v-model="form.files"/>
          </el-descriptions-item>
          <el-descriptions-item label="二维码">
            <!--                        <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>-->
          </el-descriptions-item>


        </el-descriptions>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <select-personnel ref="selectPersonnel" />


  </div>
</template>

<script>

import ErpTree from "../Common/erp-tree";
import UploadFilesSysc from "../Contract/components/UploadFilesSysc";
import ErpTreeStatus from "../Common/erp-tree-status";
import moment from "moment";
import SelectPersonnel from "../Personnel/components/selectPersonnel";

export default {
  name: "MeterNoteWrite",
  components: {SelectPersonnel, ErpTreeStatus, UploadFilesSysc, ErpTree},
  data() {
    return {
      host_url: "",
      keyword: '',
      loading: false,
      where: {
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        note_status:"",
        note_status_ids:[0,1],
        start_time:moment(new Date()).startOf('month').format("YYYY-MM-DD"),
        end_time:moment(new Date()).endOf('month').format("YYYY-MM-DD"),
        read_month:moment(new Date()).endOf('month').format("YYYY-MM"),
        read_type:1,
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 30,
        page: 1
      },
      dialogVisible: false,
      treeDialogVisible: false,
      form: {
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
      },
      update_form: {
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        end_number:"",
        meter_update_time:"",
        end_use:"",
        admin_name:"",
        admin_id:"",
      },
      uploadUrl: "",
      month_value: "",
      business_list: [],
      entry_type_name: "",
      multipleSelection: [],
      meter_type_list: [],
      house_charge_list:[],
      chargeItem_name_id:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      charging_standard:"",
    }
  },
  created() {
    this.host_url = __HTTP__.defaults.baseURL;
    // this.month_value=CommonHelp.date("YYYY-MM");
    this.getList()
    this.getMeterTypeList()
  },
  watch: {
    dialogVisible(val) {
      if (val == false) {
        // this.fileList = []
      }
    },
    "form.project_id":function (n) {
      this.getHouseChargeList();
    },
    "form.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    },
    "where.meter_type":function (n) {
      this.chargeItem_name_id=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_id||"";
      this.getHouseChargeList();
    }
  },
  computed: {
    multipleSelection_meter_type_num(){
      let set=new Set();
      this.multipleSelection.map(ret=>{
        set.add(ret.meter_type)
      });
      return Array.from(set).length;
    }
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id: '',
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: "",
        magnification: "",
        start_number: "",
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that = this;
      that.loading = true;
      let where = reObject(this.where);
      // where.is_update=0;
      ERP.getRequest({
        url: "admin/MeterNote/getMasterList",
        data: {
          where: JSON.stringify(where),
          user_type:(that.$route.query.type||0),
          page: this.pageData.page,
          page_size: this.pageData.pageSize
        }
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {
            return ret;
          })
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    getListForm(){
      return this.pageData.list.filter(ret=>{
        return !!(ret.read_number&&ret.read_time);
      }).map(ret=>{
        return {
          meter_id:ret.id,
          read_number:ret.read_number,
          dosage_number:ret.dosage_number,
          last_read_number:ret.last_read_number,
          read_time:ret.read_time,
          last_read_time:ret.last_read_time,
          admin_id:ret.admin_id,
          admin_name:ret.admin_name
        }
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    edit(item) {
      if (!item) {
        let project_id= this.form.project_id
        let house_id= this.form.house_id
        let house_name= this.form.house_name
        this.form = this.getFormData({})
        this.form.project_id=project_id;
        this.form.house_id=house_id;
        this.form.house_name=house_name;
      } else {
        this.form = reObject(item);
      }
      this.dialogVisible = true
    },

    saveListForm(){
      var that=this;
      let bool = true;
      this.pageData.list.map(ret=>{
        if(ret.read_number){
          if(ret.read_time == ''){
            bool = false;
          }
        }
      })
      if(bool === false){
        this.$Message.error('抄表日期不能为空');
        return false;
      }

      let form_data=reObject(that.getListForm());
      ERP.showLoading();
      ERP.postRequest({url: "admin/MeterNote/saveList", data: {
          form_list:JSON.stringify(form_data)
        }
      }, res => {
        ERP.hideLoading();
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    nodeClick(data) {
      let tree_str = data.tree.map(ret => {
        return ret.name
      }).join('->');
      //console.log(data);
      this.form.project_id = data.tree[0].pindex_id;
      this.form.house_name = tree_str;
      this.form.house_id = data.tree[data.tree.length - 1].house_id;
      this.where.house_name=tree_str;
    },
    getMeterTypeList(){
      var that=this;
      let where={};
      ERP.getRequest({
        url:"admin/MeterType/getList",
        data:{
          where:JSON.stringify(where),
          field:"id,name,expenditure_id,expenditure_name",
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let where={};
      this.form.project_id&&(where.pindex_id=this.form.project_id);
      this.chargeItem_name_id&&(where.chargeItem_name_id=this.chargeItem_name_id);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    navToMeterExcel(){
      ERP.navigateTo("/meter/meterExcel?type="+(this.$route.query.type||0));
    },
    onDosageNumber(item){
      item.dosage_number=(item.read_number-item.last_read_number)*item.magnification;
      item.amount=(item.dosage_number*item.charging_standard_money);
    },
    isDosageNumber(item,el){
      const self=this;
      if(item.dosage_number<0){
        self.$confirm("该读数小于0了","提示",{
          confirmButtonText: '调整',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(el)
          self.$refs[el].focus()
        });
      }
    },
    printList(){
      this.$router.push({path:"/meter/meterNotePrint",query:reObject(this.where)})
    },
    navBack(){
      ERP.navigateBack()
    },
    selectUser(item){
      const that=this;
      that.$refs.selectPersonnel.show({user_ids:"",user_len:1},ret=>{
        if(ret.length){
          item.admin_name=ret[0].username;
          item.admin_id=ret[0].id;

          that.$confirm("是否全部替换为该人员抄表","提示",{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.pageData.list.map(mtn=>{
              mtn.admin_name=ret[0].username;
              mtn.admin_id=ret[0].id;
            })
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          });


        }else {
          item.admin_name="";
          item.admin_id="";
          that.$confirm("是否清除抄表人员","提示",{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.pageData.list.map(mtn=>{
              mtn.admin_name=ret[0].username;
              mtn.admin_id=ret[0].id;
            })
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          });
        }
      })
    },
    updateTime(val){
      const that=this;
      that.$confirm(val?"是否设置为当前全部抄表时间":"是否清除当前全部抄表时间","提示",{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.pageData.list.map(mtn=>{
          mtn.read_time=val;
        })
        this.$message({
          type: 'success',
          message: val?'修改成功!':"清除成功"
        });
      });
    },
    nextLine(item,index,event){
      const that=this;
      // that.$refs['input_'+index+1].focus();
      // console.log(event.code);
      if(event.code==='ArrowDown'||event.code==='ArrowUp'){
        // console.log('input_'+(index+1))
        // console.log(that.$refs['input_'+(index+1)])
        event.code==='ArrowDown'&&index<=that.pageData.list.length&&that.$refs['input_'+(index+1)].focus();
        event.code==='ArrowDown'&&index>0&&that.$refs['input_'+(index-1)].focus();
      }
    },
  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>
<style lang="scss" scoped>

.el-button--primary, .el-button--danger, .el-button--success, .el-button--warning {
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x: scroll;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: calc(100vw - 450px);
  overflow-x: scroll;
}
.amap-box{
  width: 500px;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/MeterNoteWrite.vue